export const SHARING_INVITE_RATE_LIMIT = 'SHARING_INVITE_RATE_LIMIT';
